import translations from './translation'
import axios from 'axios';
import {SystemUrl } from '../App';
import GetPagesData from "./Routes";
const fs = require('fs');
const path = require('path');
const translationsPath = path.join(__dirname, 'translation/en.js');

export function trans(key) {
    const lang = localStorage.getItem('lang') || "en";
  /*  const hasPlaceholders = /{{\s*[^}]+\s*}}/.test(key);
    
    // TODO: handle the fail as it breaks the code when the key is not found
    if (hasPlaceholders) {
        let placeholders;
    
        // key: You cannot {{Delete}} this item because it has related:
        key = key.replace(/{{\w+}}/g, function(all) {
            
            const matches = all.match(/{{(.*?)}}/g);
            placeholders = matches.map(match => match.replace(/{{|}}/g, ''));
            
            return "{{variable}}";
        });
        if (translations[lang][key].length !== 0) {
            // key: You cannot {{variable}} this item because it has related:
            translations[lang][key] = translations[lang][key].replace(/{{\w+}}/g, function(all) {
                
                return translations[lang][placeholders];
            });        
        }        
    }*/
    // translations[lang][key]: You cannot Delete this item because it has related:
    return translations[lang][key] ? translations[lang][key] : key;
}




  


export function resetPermissions(CurrentModule) {
    axios.get(`${SystemUrl}getPermissions`).then(res => {

        var pages=res.data.data;
        var lang = localStorage.getItem('lang') || "en";
        var styleUrl = localStorage.getItem('styleUrl') || "/assets/css/style.bundle.css"

        localStorage.clear();
        localStorage.setItem('lang',lang)
        localStorage.setItem('styleUrl',styleUrl)
        localStorage.setItem('isLoggedIn', true)
        GetPagesData(pages);
        window.location.href = '/'+CurrentModule;

    })
}

export function getCustomModules(){
    return [

        {
            route: "Customer/View/:id",
            name_en: trans("Customer View"),
            module : 'Customer'
        },
        {
            route: "WasteManagement/View/:id",
            name_en: trans("Waste Management"),
            module : 'WasteManagement'
        },
        {
            route: "Project/View/:id",
            name_en: trans("Project View"),
            module : 'Project'
        }
        ,
        {
            route: "Ticket/View/:id",
            name_en: trans("Ticket Information"),
            module : 'Ticket'
        },
        {
            route: "WorkOrder/View/:id",
            name_en: trans("WorkOrder Information"),
            module : 'WorkOrder'
        },
        {
            route: "Profile/:id",
            name_en: trans("Profile"),
            module : 'Profile'
        },
        {
            route: "RoomSpaceItem/View/:id",
            name_en: trans("Allocate Asset / Item"),
            module : 'RoomSpaceItem'
        },
        {
            route: "AssignAssetItem/View/:id",
            name_en: trans("Assign Asset / Item"),
            module : 'AssignAssetItem'
        },
        {
            route: "Contract/View/:id",
            name_en: trans("Contract Details"),
            module : 'Contract'
        },
        {
            route: "RoomSpace/View/:id",
            name_en: trans("Room Space Details"),
            module : 'RoomSpace'
        },
        {
            route: "SupplierManufacturer/View/:id",
            name_en: trans("Supplier/Manufacturer/Supplier Details"),
            module : 'SupplierManufacturer'
        },
        {
            route: "InventoryTaking/View/:id",
            name_en: trans("Inventory Taking"),
            module : 'InventoryTaking'
        },
        {
            route: "InventoryTaking/Scan/:it_id",
            name_en: trans("Inventory Taking"),
            module : 'Scan',
        },
        {
            route: "InventoryTaking/AssetItemList/:it_id/:room_id",
            name_en: trans("Asset / Item List"),
            module : 'AssetItemList',
        },
        {
            route: "InventoryTaking/Charts/:it_id/:room_id",
            name_en: trans("Inventory Taking Charts"),
            module : 'finishTaking',
        },
        {
            route: "Space/View/:id",
            name_en: trans("Space"),
            module : 'Space',
        },
        {
            route: "ActivityLog/:page/:id",
            name_en: trans("ActivityLog"),
            module : 'ActivityLog',
        },
        {
            route: "ActivityLogPerUser/:user_id",
            name_en: trans("ActivityLogPerUser"),
            module : 'ActivityLogPerUser',
        }

    ];
}
